import { render, staticRenderFns } from "./LdpFormLoiNhan.vue?vue&type=template&id=66768748&scoped=true&"
import script from "./LdpFormLoiNhan.vue?vue&type=script&lang=js&"
export * from "./LdpFormLoiNhan.vue?vue&type=script&lang=js&"
import style0 from "./LdpFormLoiNhan.vue?vue&type=style&index=0&id=66768748&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66768748",
  null
  
)

export default component.exports